var _path, _path2, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStargateLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6581_11280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 2H2V21.9999H22V2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6581_11280)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6581_11280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2H2V21.9999H22V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6581_11280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9865 2.79561L14.5187 4.04227C15.5634 6.49004 17.5131 8.43972 19.9608 9.4844L21.2075 10.0166C21.5337 10.1558 21.7986 10.3553 22.0031 10.5929C21.3823 6.14149 17.8616 2.62036 13.4102 2C13.6473 2.20397 13.8473 2.46933 13.9865 2.79561Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79561 10.0166L4.04228 9.4844C6.49005 8.43972 8.43972 6.49004 9.48487 4.04227L10.0166 2.79561C10.1562 2.46933 10.3558 2.20397 10.5929 2C6.14149 2.62036 2.62084 6.14149 2 10.5929C2.20446 10.3553 2.46935 10.1558 2.79561 10.0166Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2075 13.9825L19.9608 14.5148C17.5131 15.5594 15.5634 17.5096 14.5187 19.9574L13.9865 21.2035C13.8473 21.5298 13.6473 21.7952 13.4102 21.9997C17.8616 21.3788 21.3823 17.8577 22.0031 13.4062C21.7986 13.6439 21.5337 13.8434 21.2075 13.9825Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0166 21.2035L9.48487 19.9574C8.43972 17.5096 6.49005 15.5594 4.04228 14.5148L2.79561 13.9825C2.46935 13.8434 2.20446 13.6439 2 13.4062C2.62084 17.8577 6.14149 21.3788 10.5929 21.9997C10.3558 21.7952 10.1562 21.5298 10.0166 21.2035Z",
    fill: "#999999"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46176 11.022L8.07616 10.7596C9.28223 10.2447 10.2432 9.28422 10.7581 8.07815L11.0201 7.46372C11.3874 6.60324 12.6073 6.60324 12.9747 7.46372L13.2366 8.07815C13.7515 9.28422 14.7125 10.2447 15.9186 10.7596L16.533 11.022C17.3935 11.3894 17.3935 12.6088 16.533 12.9762L15.9186 13.2386C14.7125 13.7535 13.7515 14.7139 13.2366 15.9206L12.9747 16.5344C12.6073 17.3949 11.3874 17.3949 11.0201 16.5344L10.7581 15.9206C10.2432 14.7139 9.28223 13.7535 8.07616 13.2386L7.46176 12.9762C6.60129 12.6088 6.60129 11.3894 7.46176 11.022Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStargateLogo);
export default __webpack_public_path__ + "static/media/stargate_logo.a8d958b586717020f1a60778744aa90c.svg";
export { ForwardRef as ReactComponent };